export default __webpack_public_path__ + "alberta-parenteral-feeding.a1d3816d02aafa5824b9.svg";